import React from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {Row, Col, Form, FormGroup, Label, Input, Button} from 'reactstrap';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import 'font-awesome/css/font-awesome.css';

import {RootState} from 'app/rootReducer';
import {fetchFilterTree, fetchFilterId, treeSelect, treeExpand, setFilterNeedsReview, redirectToImages} from './selectFilterSlice';

type Props = ConnectedProps<typeof connector>;
class SelectFilterPage extends React.Component<Props, any>{
    
    componentDidMount() {
        const {filterTree, fetchFilterTree} = this.props;
        if (!filterTree || !filterTree.length) {
            fetchFilterTree(false);
        }
    }

    render() {
        const {filterTree, expandedTreeItems, selectedTreeItems, treeSelect, treeExpand, filterNeedsReview, setFilterNeedsReview} = this.props;
        if (!filterTree || filterTree.length === 0) return null;
        
        const handleContinue = async () => {
            const {fetchFilterId, redirectToImages} = this.props;
            await fetchFilterId();
            if (this.props.filterId) {
                await redirectToImages();
            }
        };
        
        return <> 
            <Row>
                <Col md={10}>
                    <h2>Select images to review</h2>
                </Col>
                <Col md={2}>
                    <Button outline disabled={!selectedTreeItems.length} onClick={handleContinue}>Continue <i className="fa fa-angle-double-right" aria-hidden="true"/></Button>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={12}>
                    <Row>
                        <Col md={12} className="pb-3">
                            <h5>Filter images</h5>
                            <Form>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" name="filterNeedsReview" checked={filterNeedsReview}
                                               onChange={() => setFilterNeedsReview(true)} />{' '}Not processed
                                    </Label>
                                </FormGroup>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" name="filterNeedsReview" checked={!filterNeedsReview}
                                               onChange={() => setFilterNeedsReview(false)} />{' '}All
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <h5>Select units</h5>
                            <CheckboxTree 
                                optimisticToggle={false} 
                                nodes={filterTree} 
                                checked={selectedTreeItems}
                                expanded={expandedTreeItems}
                                onCheck={checked => treeSelect(checked)}
                                onExpand={expanded => treeExpand(expanded)}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>;
    }
}

const mapStateToProps = (state: RootState) => state.selectFilter;
const mapDispatchToProps = {fetchFilterTree, fetchFilterId, treeSelect, treeExpand, setFilterNeedsReview, redirectToImages};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(SelectFilterPage);